<template>
    <div :class="['upsell-tag', classes]">
        <span class="typographies-paragraph-small-regular">{{ tagLabel }}</span>
    </div>
</template>
<script>
export default {
    props: {
        quantity: {
            type: Number,
            default: 0,
        },
        label: {
            type: String,
            required: true,
        },
        showQuantity: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            const status = this.quantity > 0 ? 'added' : 'removed';
            return this.quantity !== 0 ? `upsell-tag--is-${status}` : '';
        },
        tagLabel() {
            if (this.quantity !== 0) {
                const symbol = this.quantity > 0 ? '+' : '-';
                if (!this.showQuantity) {
                    return `${symbol} ${this.label}`;
                } else {
                    const quantity = this.quantity < 0 ? this.quantity * -1 : this.quantity;
                    return `${symbol} ${quantity.toString()} ${this.label}`;
                }
            }

            return this.label;
        },
    },
};
</script>
<style lang="scss" scoped>
.upsell-tag {
    margin-left: var(--spacing-0);
    height: 16px;
    border-radius: 4px;
    border: solid 1px var(--colors-common-border-default);
    padding: 0 var(--spacing-0);
    background-color: var(--colors-component-background-information-tag-stroked);
    white-space: nowrap;

    span {
        color: var(--colors-common-text-standard-default);
    }

    &--is-added span,
    &--is-removed span {
        color: var(--colors-common-text-standard-on-color);
    }

    &--is-added {
        border-color: var(--colors-common-background-success-darker);
        background-color: var(--colors-common-background-success-darker);
    }

    &--is-removed {
        border-color: var(--colors-common-background-alert-darker);
        background-color: var(--colors-common-background-alert-darker);
    }
}
</style>
